import * as React from "react";

import { PieChart } from "@mui/x-charts/PieChart";

export default function MyPieChart({ pieData }) {
  const data = Array.isArray(pieData) ? pieData : [];

  return (
    <PieChart
      series={[
        {
          data,
        },
      ]}
      width={300}
      height={300}
    />
  );
}
